import React from "react";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import _ from "underscore";
import {getImageSize} from "../../common/utils";
import config from "../../../config";
import Currency from "../../common/Currency";
import InternationalCurrency from "../../common/InternationalCurrency";
import { filterLineItems } from "../../cart/helpers"
import { openShopifyCart } from "../../actionCreators/shopifyAC";
import { useDispatch } from "react-redux";

const PersonalizedCartModule = ({cart, isInternational, selectedCountry}) => {
    const dispatch = useDispatch();
    const {lines} = cart;
    const filteredLineItems = filterLineItems(lines);
    const cart_limit = 5;

    return (
        <div className="homepage-personalization__returning-user-cart">
            <div className="homepage-personalization__title">
                Your Cart Is Waiting
            </div>
            {filteredLineItems &&
            <div className="returning-user-cart__line-items">
                {_.last(_.map(filteredLineItems, (lineItem, idx) => {
                    const item_variant = lineItem.merchandise;
                    const item_available = item_variant.availableForSale;
                    const item_product = item_variant.product;
                    const item_condition = item_product && item_product.condition && item_product.condition.value;
                    const item_quantity = parseInt(lineItem.quantity);
                    const item_link = item_variant.product.handle;

                    return (
                        <div className="returning-user-cart__line-item" key={idx}>
                            <a
                                className="returning-user-cart__line-item-link"
                                href={`${config.host_rebag_shop}/products/${item_link}`}
                            >
                                <div className="returning-user-cart__line-items-thumb-container">
                                    <Image
                                        className="returning-user-cart__line-items-thumb"
                                        src={item_variant.image && item_variant.image.url ? getImageSize(item_variant.image.url) : config.PLACE_HOLDER}
                                        alt={item_product.title}
                                        title={item_product.title}
                                    />
                                </div>
                                <div className="returning-user-cart__line-items-info">
                                    <div className="returning-user-cart__line-items-title">
                                        <strong>{item_product.vendor}</strong> {item_product.title}
                                    </div>
                                    {item_available && item_condition &&
                                        <div className="returning-user-cart__line-items-condition">
                                            Condition: {item_condition}
                                        </div>
                                    }
                                    <div className="returning-user-cart__line-items-price">
                                        {isInternational ?
                                            <InternationalCurrency value={parseFloat(item_variant.price.amount) * item_quantity} currencySymbol={selectedCountry.currency.symbol} />
                                            :
                                            <Currency value={parseFloat(item_variant.price.amount) * item_quantity} />
                                        }
                                    </div>
                                </div>
                            </a>
                            <div className="returning-user-cart__cta-container">
                                <Button
                                    className="rbg-btn-dark returning-user-cart__cta"
                                    variant="clean"
                                    onClick={() => dispatch(openShopifyCart(false))}
                                >
                                    View Cart
                                </Button>
                            </div>
                        </div>
                    )
                }), cart_limit)}
            </div>
            }
        </div>
    )
}

export default PersonalizedCartModule;